import { render, staticRenderFns } from "./BordereauLivraison.vue?vue&type=template&id=2ae9cb36"
import script from "./BordereauLivraison.vue?vue&type=script&lang=js"
export * from "./BordereauLivraison.vue?vue&type=script&lang=js"
import style0 from "./BordereauLivraison.vue?vue&type=style&index=0&id=2ae9cb36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports